import {
  INQUIRY_FF_SET_FILTER,
  INQUIRY_FF_APPLY_FILTER,
  INQUIRY_FF_DISABLE_LOADING,
  INQUIRY_FF_ENABLE_LOADING,
  INQUIRY_FF_PAGINATION,
  INQUIRY_FF_RESET_FILTER,
  INQUIRY_FF_RESET_PAGINATION,
  INQUIRY_FF_SET_PREV_PAGINATION,
  INQUIRY_FF_UPDATE_DATA,
  INQUIRY_FF_GET_STATUS_WISE_COUNT,
  INQUIRY_FF_FETCH_ERROR,
  INQUIRY_FF_APPLY_SORT,
  INQUIRY_FF_DETAILS,
  INQUIRY_FF_BIDS_RANKING_DATA,
  INQUIRY_FF_BIDS_RANKING_DATA_IS_LOADING,
  INQUIRY_FF_BOOKING_STAT_COUNTS_DATA,
  INQUIRY_FF_BOOKING_STAT_COUNTS_DATA_IS_LOADING,
} from 'src/actions/constants';

const defaultState = {
  inquiryFFDetails: [],
  isLoading: false,
  appliedFilters: {
    status: 'ALL',
    sortBy: 'received_date',
    descendingOrder: true,
    modeList: [],
    shipperList: [],
    originCityList: [],
    destinationCityList: [],
    originCountryList: [],
    destinationCountryList: [],
    polList: [],
    podList: [],
  },
  selectedFilters : {
    status: 'ALL',
    modeList: [],
    polSearch: 'port',
    podSearch: 'port',
    shipperList: [],
    originCityList: [],
    destinationCityList: [],
    originCountryList: [],
    destinationCountryList: [],
    polList: [],
    podList: [],
  },
  pagination: {
    currentPageNumber: 1,
    nextOrPrev: 'first',
    resultPerPage: 10,
  },
  prevPagination : {
    currentPageNumber: 1,
    resultPerPage: 10,
    nextOrPrev: 'first',
  },
  errorMessage: '',
  inquiryFfBidsRankingData: {},
  isLoadingInquiryFfBidsRankingData: false,
  inquiryFfBookingStatCountsData: {},
  isLoadinginquiryFfBookingStatCountsData: false
};

export default function (state: typeof defaultState = defaultState, action) {
  switch (action.type) {

    case INQUIRY_FF_BOOKING_STAT_COUNTS_DATA: {
      return {
        ...state,
        inquiryFfBookingStatCountsData: action.data,
      }
    }

    case INQUIRY_FF_BOOKING_STAT_COUNTS_DATA_IS_LOADING: {
      return {
        ...state,
        isLoadinginquiryFfBookingStatCountsData: action.data,
      }
    }

    case INQUIRY_FF_BIDS_RANKING_DATA: {
      return {
        ...state,
        inquiryFfBidsRankingData: action.data,
      }
    }

    case INQUIRY_FF_BIDS_RANKING_DATA_IS_LOADING: {
      return {
        ...state,
        isLoadingInquiryFfBidsRankingData: action.data,
      }
    }

    case INQUIRY_FF_UPDATE_DATA: {
      return {
        ...state,
        data: action.data ? action.data.data : [],
        prevPagination : {
          ...state.pagination,
        },
        pagination: {
          ...state.pagination,
          currentPageNumber: action.data && action.data.currentPageNumber,
          isNextPresent: action.data && action.data.isNextPresent,
          lastSortedColumnValueNext: action.data && action.data.lastSortedColumnValueNext,
          lastSortedColumnValuePrev: action.data && action.data.lastSortedColumnValuePrev,
          lastItemIdNext: action.data && action.data.lastItemIdNext,
          lastItemIdPrev: action.data && action.data.lastItemIdPrev,
          nextOrPrev: action.data && action.data.nextOrPrev,
        },
      };
    }
    case INQUIRY_FF_GET_STATUS_WISE_COUNT: {
      return {
        ...state,
        statusWiseInquiryCount: action.data,
      };
    }
    case INQUIRY_FF_ENABLE_LOADING: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case INQUIRY_FF_DISABLE_LOADING: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case INQUIRY_FF_SET_FILTER: {
      return {
        ...state,
        selectedFilters: {
          ...state.selectedFilters,
          ...action.data,
        },
      };
    }
    case INQUIRY_FF_APPLY_SORT: {
      return {
        ...state,
        appliedFilters: {
          ...state.appliedFilters,
          ...action.data,
        },
      };
    }

    case INQUIRY_FF_APPLY_FILTER : {
      return {
        ...state,
        appliedFilters: {
          ...state.appliedFilters,
          ...state.selectedFilters,
        },
      };
    }
    case INQUIRY_FF_RESET_FILTER: {
      return {
        ...state,
        appliedFilters: defaultState.appliedFilters,
        selectedFilters: defaultState.selectedFilters,
      };
    }
    case INQUIRY_FF_PAGINATION: {
      return {
        ...state,
        pagination: {
          ...state.pagination,
          ...action.data,
        },
      };
    }
    case INQUIRY_FF_RESET_PAGINATION: {
      return {
        ...state,
        pagination: {
          currentPageNumber : 1,
          nextOrPrev: 'first',
          resultPerPage: state.pagination.resultPerPage,
        },
      };
    }

    case INQUIRY_FF_SET_PREV_PAGINATION: {
      return {
        ...state,
        pagination: state.prevPagination,
      };
    }
    case INQUIRY_FF_FETCH_ERROR: {
      return {
        ...state,
        errorMessage: action.data,
      };
    }
    case INQUIRY_FF_DETAILS: {
      return {
        ...state,
        inquiryFFDetails: action.data,
      };
    }
    default: return state;
  }
}
